import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { PropTypes } from '~/utils';
import moment from 'moment';

export function useCurrentDate( format ) {
  const [ date, setDate ] = useState( moment() );
  const tick = () => setDate( moment() );

  useEffect( () => {
    const tid = setInterval( () => tick(), 1000 );
    return () => clearInterval( tid );
  } );

  return date;
}

export function Clock( { format, ...props } ) {
  const date = useCurrentDate();

  return <time {...props}>{ date.format( format ) }</time>;

}
Clock.propTypes = {
  format  : PropTypes.string,
};
Clock.defaultProps = {
  format  : 'HH:mm',
};
